import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import SubstituteProductsState from "@store/Framework/Store/Store/Components/SubstituteProducts/SubstituteProductsState";
import { Draft } from "immer";

const initialState: SubstituteProductsState = {
    productsIds: [],
};

const actions = {
    "Components/SubstituteProducts/SetProductIds": (
        draft: Draft<SubstituteProductsState>,
        action: { productIds: string[] },
    ) => {
        draft.productsIds = action.productIds;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type SubstituteProductsActions = Parameters<typeof reducer>[1];
export default reducer;
